import React from 'react';
import Button from '@Components/Button';

const GSFNButton = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      buttonConfig={{
        className: 'insert-structure-from-name-button',
        label: 'Insert structure from name',
        type: 'tertiary',
        size: 'md',
        e2eName: 'insert-structure-from-name',
      }}
      iconConfig={{
        name: 'chevron-right',
      }}
    />
  );
}

export default GSFNButton;
